///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, usersManagerActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getAdminUsers = function* ({ payload }) {
	const bodyMsg = payload.filters
	const queryParam = payload.queryParam
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ADMIN_USERS(queryParam)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(usersManagerActionCreators.getAdminUsersSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(usersManagerActionCreators.getAdminUsersFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getUserDetail = function* ({ payload }) {
	const idUser = payload.idUser
	const user = yield select(selectIdsUser)
	user['idUser'] = idUser
	const apiCall = R.GET_USER_DETAIL(user)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(usersManagerActionCreators.getUserDetailSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(usersManagerActionCreators.getUserDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postUserCreate = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_USER_CREATE(user)
	const dataUser = payload.user
	let dataFomat = {
		userAccountInput: {
			idPreferedLanguage: dataUser.idPreferedLanguage,
			firstName: dataUser.firstName,
			lastName: dataUser.lastName,
			userName: dataUser.userName,
			email: dataUser.email,
		},
		idRole: dataUser.idRole,
		kiosks: dataUser.kiosks,
		idCompanyTyped: dataUser.idCompanyTyped,
		idCompanyService: dataUser.idCompanyService > 0 ? dataUser.idCompanyService : null,
		enabled: dataUser.enabled,
	}

	if (dataUser.phoneNumber.length > 0) dataFomat.userAccountInput.phoneNumber = dataUser.phoneNumber

	const redirectRequest = `${uriList.users}${uriList.usersManager}`
	const MsgParams = 'toast__userDetail__createUser'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		yield API_TOKEN(user.jwt).post(apiCall, dataFomat)

		yield put(usersManagerActionCreators.postUserCreateSuccess(dataUser))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(usersManagerActionCreators.postUserCreateFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateUserDetail = function* ({ payload }) {
	const idUser = payload.idUser
	const user = yield select(selectIdsUser)
	user['idUser'] = idUser
	const apiCall = R.UPDATE_USER_DETAIL(user)
	const dataUser = payload.user
	const redirectRequest = uriList.users + '/manager'
	let dataFomat = {
		userAccountInput: {
			idPreferedLanguage: dataUser.idPreferedLanguage,
			firstName: dataUser.firstName,
			lastName: dataUser.lastName,
			email: dataUser.email,
		},
		idRole: dataUser.idRole,
		kiosks: dataUser.kiosks,
		idCompanyTyped: dataUser.idCompanyTyped,
		idCompanyService: dataUser.idCompanyService > 0 ? dataUser.idCompanyService : null,
		enabled: dataUser.enabled,
	}

	if (dataUser.phoneNumber.length > 0) dataFomat.userAccountInput.phoneNumber = dataUser.phoneNumber

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, dataFomat)

		yield put(usersManagerActionCreators.updateUserDetailSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__userDetail__updateUser', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(usersManagerActionCreators.updateUserDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const deleteAdminUser = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idUser = payload.idUser
	user['idUser'] = idUser
	const scope = payload.scope
	let apiCall

	yield put(globalLoadingActionCreators.startLoading())

	if (scope === 'delete') {
		apiCall = R.DELETE_ADMIN_USER(user)
	}
	if (scope === 'disable') {
		apiCall = R.DISABLED_ADMIN_USER(user)
	}
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(usersManagerActionCreators.deleteAdminUserSuccess(data.data, idUser, scope))

		scope === 'disable'
			? yield put(
					toastSuccessActionCreators.hydrateToast(
						'page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_disableUser_modalUpdateSuccess_title'
					)
			  )
			: yield put(
					toastSuccessActionCreators.hydrateToast(
						'page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_deleteUser_modalUpdateSuccess_title'
					)
			  )
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(usersManagerActionCreators.deleteAdminUserFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const UserDetailResetPassword = function* ({ payload }) {
	const idUser = payload.idUser
	const user = yield select(selectIdsUser)
	user['idUser'] = idUser
	const apiCall = R.USER_DETAIL_RESET_PASSWORD(user)

	//yield put(globalLoadingActionCreators.startLoading());

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(usersManagerActionCreators.UserDetailResetPasswordSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast('toast__userDetail__user_passwordForceGeneration'))
	} catch (e) {
		//yield put(errorManagerActionCreators.createError(e.response));

		yield put(usersManagerActionCreators.UserDetailResetPasswordFailure(e.response))
	} finally {
		//yield put(globalLoadingActionCreators.endLoading());
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_ADMIN_USERS, getAdminUsers)
	yield takeLatest(ActionsTypes.GET_USER_DETAIL, getUserDetail)
	yield takeLatest(ActionsTypes.POST_USER_CREATE, postUserCreate)
	yield takeLatest(ActionsTypes.UPDATE_USER_DETAIL, updateUserDetail)
	yield takeLatest(ActionsTypes.DELETE_ADMIN_USER, deleteAdminUser)
	yield takeLatest(ActionsTypes.USER_DETAIL_RESET_PASSWORD, UserDetailResetPassword)
}

export default sagas
